var _defs, _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagellanLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg182",
    width: 330.0787,
    height: 56.693333,
    viewBox: "0 0 330.0787 56.693332",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs186"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath198"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,117.269 H 377.729 V 0 H 0 Z",
    id: "path196"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g190",
    transform: "matrix(1.3333333,0,0,-1.3333333,-83.937465,100.49693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g194",
    clipPath: "url(#clipPath198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g200",
    transform: "translate(96.9691,32.8527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -25.512 c -4.696,0 -8.504,3.807 -8.504,8.504 v 25.512 c 0,4.696 3.808,8.504 8.504,8.504 L 0,42.52 c 4.697,0 8.504,-3.808 8.504,-8.504 V 8.504 C 8.504,3.807 4.697,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path202"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g204",
    transform: "translate(72.3502,46.2386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.372,0.173 -0.763,0.255 -1.148,0.255 -1.024,0 -2.006,-0.581 -2.467,-1.571 -0.635,-1.362 -0.046,-2.981 1.316,-3.616 0.372,-0.173 0.763,-0.255 1.148,-0.255 1.024,0 2.006,0.582 2.467,1.572 C 1.951,-2.254 1.362,-0.635 0,0",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g208",
    transform: "translate(76.0014,64.2558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0.371,-0.961 c 0.169,0.098 0.338,0.196 0.523,0.269 0.254,0.101 0.516,0.169 0.781,0.216 L 1.298,0.501 C 0.526,2.499 -0.9,2.918 -1.96,2.918 c -0.717,0 -1.376,-0.177 -1.963,-0.529 -1.029,-0.634 -1.573,-1.6 -1.573,-2.795 v -16.175 c 0.228,0.041 0.46,0.069 0.697,0.069 v 0 c 0.236,0 0.465,-0.035 0.694,-0.076 v 16.182 c 0,0.716 0.29,1.227 0.905,1.606 0.366,0.22 0.772,0.326 1.24,0.326 C -1.372,1.526 -0.529,1.368 0,0",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path210"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g212",
    transform: "translate(80.8878,60.8738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.553,1.397 -2.135,2.081 -3.532,1.528 -4.929,0.975 -5.613,-0.607 -5.06,-2.004 -4.507,-3.401 -2.925,-4.086 -1.528,-3.532 -0.131,-2.979 0.553,-1.397 0,0",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path214"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g216",
    transform: "translate(95.4824,65.5234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.715,-0.374 1.048,-0.906 1.048,-1.673 v -10.171 c 0.226,0.04 0.457,0.07 0.695,0.07 0.239,0 0.469,-0.03 0.696,-0.07 v 10.171 c 0,1.286 -0.62,2.291 -1.79,2.904 -0.525,0.278 -1.143,0.419 -1.834,0.419 -1.02,0 -2.398,-0.419 -3.17,-2.416 l -5.101,-13.218 c -0.354,-0.917 -1.169,-1.244 -1.814,-1.244 -0.644,0 -1.459,0.327 -1.813,1.244 l -1.921,4.978 c -0.207,-0.13 -0.426,-0.246 -0.658,-0.338 -0.206,-0.081 -0.418,-0.138 -0.631,-0.184 l 1.913,-4.957 c 0.5,-1.296 1.721,-2.134 3.11,-2.134 1.39,0 2.612,0.838 3.112,2.134 l 5.1,13.217 c 0.529,1.369 1.322,1.527 1.873,1.527 C -0.723,0.259 -0.325,0.172 0,0",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path218"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g220",
    transform: "translate(97.2258,52.4995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.503,0 -2.721,-1.218 -2.721,-2.721 0,-1.503 1.218,-2.722 2.721,-2.722 1.503,0 2.721,1.219 2.721,2.722 C 2.721,-1.218 1.503,0 0,0",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path222"
  })))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1,0,0,-1,125.4409,51.9341)",
    style: {
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 32,
      fontFamily: "'Gill Sans MT'",
      InkscapeFontSpecification: "GillSansMT",
      writingMode: "lr-tb",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "text226"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "0 28.191999 51.452801 78.332802 97.532799 116.4128 135.2928 159.83681",
    y: 0,
    id: "tspan224"
  }, "MAGELLAN"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1,0,0,-1,126.7285,34.1201)",
    style: {
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 11,
      fontFamily: "'Caviar Dreams'",
      InkscapeFontSpecification: "CaviarDreams-Bold",
      writingMode: "lr-tb",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "text230"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "0 9.5150003 19.657 30.682301 43.354301 53.6833 60.4758 71.618797 84.422798 90.7258 100.4883 114.4803 123.6103 134.9183 144.4333 151.2258 165.2178 176.36079",
    y: 0,
    id: "tspan228"
  }, "TRACKING SOLUTIONS")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagellanLogoDark);
export default __webpack_public_path__ + "static/media/magellan_logo_dark.89e8605fd0c3e4c51f1715402bbaf85c.svg";
export { ForwardRef as ReactComponent };